import API from "../components/helpers/endpointservice";
import Actions from './api';

// export const getSsoDetails = () => {
//     return (dispatch) => {
//         //Loader true
//         dispatch({ type: "IS_LOADER", data: true });
//         Actions.GET(`${API.GET_SSO_DETAILS}`).then((res) => {
//             if (res.data !== undefined) {
//                 dispatch({ type: "SETTING_SSO_LOADED_SUCCESS", data: res.data });
//             }
//             //Loader false
//             dispatch({ type: "IS_LOADER", data: false });
//         }).catch((error) => {
//             //Loader false
//             dispatch({ type: "IS_LOADER", data: false });
//         });
//     }
// };

export const getSsoDetails = () => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            //Loader true
            dispatch({ type: "IS_LOADER", data: true });
            Actions.GET(`${API.GET_SSO_DETAILS}`).then((res) => {
                if (res.data !== undefined) {
                    dispatch({ type: "SETTING_SSO_LOADED_SUCCESS", data: res.data });
                    resolve(res.data);
                }
                else {
                    reject(new Error("No data in response"));
                }
                //Loader false
                dispatch({ type: "IS_LOADER", data: false });
            })
                .catch((error) => {
                    console.log("error", error)
                    //Loader false
                    dispatch({ type: "IS_LOADER", data: false });
                    reject(error)
                });
        });
    };
};



export const createIdentityProviders = (data) => {
    
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            //Loader true
            dispatch({ type: "IS_LOADER", data: true });
            Actions.POST(`${API.POST_SSO_DETAILS}`, data).then((res) => {
                // if (res.data !== undefined) {
                console.log(res);
                if (res.status == 200) {
                    dispatch({ type: "CREATE_SSO_LOADED_SUCCESS", data: res.data });
                    dispatch({ type: "IS_LOADER", data: false });
                    resolve(res.data)
                }
                else {
                    dispatch({ type: "IS_LOADER", data: false });
                }
                //Loader false
                // dispatch({ type: "IS_LOADER", data: false });
            }).catch((error) => {
                //Loader false
                dispatch({ type: "IS_LOADER", data: false });
            });
        });
    };
};

export const updateIdentityProviders = (data) => {
    
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            //Loader true
            dispatch({ type: "IS_LOADER", data: true });
            Actions.PUT(`${API.PUT_SSO_DETAILS}`, data).then((res) => {
                if (res.data !== undefined) {
                    resolve(res.data)
                    dispatch({ type: "UPDATE_SSO_LOADED_SUCCESS", data: res.data });
                    Actions.POST(`${API.LOGOUT_SESSIONS}`).then((res) => {
                        console.log(res);
                        dispatch({ type: "LOGOUT_ALLUSERS", data: res.data });
                    }).catch((error) => {
                        //Loader false
                        dispatch({ type: "IS_LOADER", data: false });
                    });
                }
                //Loader false
                dispatch({ type: "IS_LOADER", data: false });
            }).catch((error) => {
                //Loader false
                dispatch({ type: "IS_LOADER", data: false });
            });
        });
    };
};

// export const updateIdentityProviders = (data) => {
//     return (dispatch) => {
//         //Loader true
//         dispatch({ type: "IS_LOADER", data: true });
//         Actions.PUT(`${API.PUT_SSO_DETAILS}`, data).then((res) => {
//             if (res.data !== undefined) {
//                 dispatch({ type: "UPDATE_SSO_LOADED_SUCCESS", data: res.data });
//                 Actions.POST(`${API.LOGOUT_SESSIONS}`).then((res) => {
//                     console.log(res);
//                         dispatch({ type: "LOGOUT_ALLUSERS", data: res.data });
//                 }).catch((error) => {
//                     //Loader false
//                     dispatch({ type: "IS_LOADER", data: false });
//                 });
//             }
//             //Loader false
//             dispatch({ type: "IS_LOADER", data: false });
//         }).catch((error) => {
//             //Loader false
//             dispatch({ type: "IS_LOADER", data: false });
//         });
//     }
// };

export const deleteIdentityProviders = (data) => {
    return (dispatch) => {
        //Loader true
        dispatch({ type: "IS_LOADER", data: true });
        Actions.DELETE(`${API.DELETE_SSO_DETAILS}${data}`).then((res) => {
            if (res.status == 200) {
                dispatch({ type: "DELETE_SSO_LOADED_SUCCESS", data: res.data });
                dispatch({ type: "IS_LOADER", data: false });
            }
            //Loader false
            dispatch({ type: "IS_LOADER", data: false });
        }).catch((error) => {
            //Loader false
            dispatch({ type: "IS_LOADER", data: false });
        });
    }
};

export const LogoutAllUsers = () => {

    return (dispatch) => {
        //Loader true
        dispatch({ type: "IS_LOADER", data: true });
        Actions.POST(`${API.LOGOUT_SESSIONS}`).then((res) => {
            // if (res.data !== undefined) {
            console.log(res);
            //  if(res.status==200){
            dispatch({ type: "LOGOUT_ALLUSERS", data: res.data });
            //     dispatch({ type: "IS_LOADER", data: false });
            // }
            // else{
            //     dispatch({ type: "IS_LOADER", data: false });
            // }
            //Loader false
            // dispatch({ type: "IS_LOADER", data: false });
        }).catch((error) => {
            //Loader false
            dispatch({ type: "IS_LOADER", data: false });
        });
    }
};


export const GetGlobalSettings = (tenantId) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            //Loader true
            dispatch({ type: "IS_LOADER", data: true });
            Actions.GET(`${API.GET_GLOBAL_SETTINGS}`).then((res) => {
                if (res.data !== undefined) {
                    dispatch({ type: "SETTING_SSO_LOADED_SUCCESS", data: res.data });
                    resolve(res.data);
                }
                else {
                    reject(new Error("No data in response"));
                }
                //Loader false
                dispatch({ type: "IS_LOADER", data: false });
            })
                .catch((error) => {
                    console.log("error", error)
                    //Loader false
                    dispatch({ type: "IS_LOADER", data: false });
                    dispatch({ type: "IS_LOADER", data: false });
                    reject(error)
                });
        });
    };
};




export const updateGlobalSettings = (data) => {
    
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            //Loader true
            dispatch({ type: "IS_LOADER", data: true });
            Actions.PUT(`${API.GLOBAL_SETTINGS_API_UPDATE}`, data).then((res) => {
                if (res.data !== undefined) {
                    resolve(res.data)
                    dispatch({ type: "UPDATE_SSO_LOADED_SUCCESS", data: res.data });
                    Actions.POST(`${API.LOGOUT_SESSIONS}`).then((res) => {
                        console.log(res);
                        dispatch({ type: "LOGOUT_ALLUSERS", data: res.data });
                    }).catch((error) => {
                        //Loader false
                        dispatch({ type: "IS_LOADER", data: false });
                    });
                }
                //Loader false
                dispatch({ type: "IS_LOADER", data: false });
            }).catch((error) => {
                //Loader false
                dispatch({ type: "IS_LOADER", data: false });
            });
        });
    };
};






export const Language = () => {
    return (dispatch) => {
        
        return new Promise((resolve, reject) => {
            //Loader true
            dispatch({ type: "IS_LOADER", data: true });
            Actions.GET(`${API.GET_LANGUAGE}`).then((res) => {
                if (res.data !== undefined) {
                    dispatch({ type: "SETTING_SSO_LOADED_SUCCESS", data: res.data });
                    resolve(res.data);
                }
                else {
                    reject(new Error("No data in response"));
                }
                //Loader false
                dispatch({ type: "IS_LOADER", data: false });
            })
                .catch((error) => {
                    console.log("error", error)
                    //Loader false
                    dispatch({ type: "IS_LOADER", data: false });
                    dispatch({ type: "IS_LOADER", data: false });
                });
        });
    };
};
export const DateFormat = () => {
    return (dispatch) => {
        
        return new Promise((resolve, reject) => {
            //Loader true
            dispatch({ type: "IS_LOADER", data: true });
            Actions.GET(`${API.GET_DATEFormat}`).then((res) => {
                if (res.data !== undefined) {
                    dispatch({ type: "SETTING_SSO_LOADED_SUCCESS", data: res.data });
                    resolve(res.data);
                }
                else {
                    reject(new Error("No data in response"));
                }
                //Loader false
                dispatch({ type: "IS_LOADER", data: false });
            })
                .catch((error) => {
                    console.log("error", error)
                    //Loader false
                    dispatch({ type: "IS_LOADER", data: false });
                    dispatch({ type: "IS_LOADER", data: false });
                });
        });
    };
};

export const country = () => {
    return (dispatch) => {
        
        return new Promise((resolve, reject) => {
            //Loader true
            dispatch({ type: "IS_LOADER", data: true });
            Actions.GET(`${API.GET_COUNTRY}`).then((res) => {
                if (res.data !== undefined) {
                    dispatch({ type: "SETTING_SSO_LOADED_SUCCESS", data: res.data });
                    resolve(res.data);
                }
                else {
                    reject(new Error("No data in response"));
                }
                //Loader false
                dispatch({ type: "IS_LOADER", data: false });
            })
                .catch((error) => {
                    console.log("error", error)
                    //Loader false
                    dispatch({ type: "IS_LOADER", data: false });
                    dispatch({ type: "IS_LOADER", data: false });
                });
        });
    };
};
export const TimeZone = () => {
    return (dispatch) => {
        
        return new Promise((resolve, reject) => {
            //Loader true
            dispatch({ type: "IS_LOADER", data: true });
            Actions.GET(`${API.GET_TimeZone}`).then((res) => {
                if (res.data !== undefined) {
                    dispatch({ type: "SETTING_SSO_LOADED_SUCCESS", data: res.data });
                    resolve(res.data);
                }
                else {
                    reject(new Error("No data in response"));
                }
                //Loader false
                dispatch({ type: "IS_LOADER", data: false });
            })
                .catch((error) => {
                    console.log("error", error)
                    //Loader false
                    dispatch({ type: "IS_LOADER", data: false });
                    dispatch({ type: "IS_LOADER", data: false });
                });
        });
    };
};